import { Link } from 'react-router-dom';
import { Radio } from 'lucide-react';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border-subtle bg-bg-secondary px-4 py-14 text-sm text-fg-muted md:px-6">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-10 md:grid-cols-3">
          {/* Über */}
          <div>
            <Link to="/" className="mb-4 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-emergency">
                <Radio className="h-4 w-4 text-white" aria-hidden />
              </span>
              <span className="font-display text-lg font-semibold text-fg-primary">
                Dispatch<span className="text-accent-emergency">24</span>
              </span>
            </Link>
            <p className="leading-relaxed">
              Dispatch24 ist eine Hobby-Entwicklung. Inspiriert von echten Leitstellen, gebaut
              mit React und MapLibre. Keine Verbindung zu offiziellen Behörden.
            </p>
          </div>

          {/* Rechtliches */}
          <div>
            <p className="mb-3 text-xs uppercase tracking-widest text-fg-secondary">
              Rechtliches
            </p>
            <nav aria-label="Rechtliches" className="flex flex-col gap-2">
              <Link to="/legal/imprint" className="transition-colors hover:text-fg-primary">
                Impressum
              </Link>
              <Link to="/legal/privacy" className="transition-colors hover:text-fg-primary">
                Datenschutz
              </Link>
            </nav>
          </div>

          {/* Kontakt */}
          <div>
            <p className="mb-3 text-xs uppercase tracking-widest text-fg-secondary">
              Kontakt
            </p>
            <ul className="flex flex-col gap-2">
              <li>
                <a
                  href="mailto:kontakt@dispatch24.example"
                  className="transition-colors hover:text-fg-primary"
                >
                  kontakt@dispatch24.example
                </a>
              </li>
              <li>
                <a
                  href="https://discord.gg/dispatch24"
                  rel="noopener noreferrer"
                  className="transition-colors hover:text-fg-primary"
                >
                  Discord-Server
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/dispatch24"
                  rel="noopener noreferrer"
                  className="transition-colors hover:text-fg-primary"
                >
                  GitHub-Issues
                </a>
              </li>
            </ul>
          </div>
        </div>

        <p className="mt-10 border-t border-border-subtle pt-6 text-center text-xs">
          © {year} Dispatch24. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>
  );
}
